import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearDesignationDetails } from "./designationSlice";
import {
  createDesignation,
  getAllDesignation,
  getDesignationByID,
  updateDesignation,
} from "./services/designation.services";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import { closed } from "../../components/drawer/drawerSlice";
import IconButton from "../../components/common/IconButton";
import FormRichTextField from "../../components/formFields/FormRichTextField";

const CreateDesignation: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const DesignationDetail = useAppSelector(
    (state) => state.designation.DesignationDetail
  );
  const DesignationID = useAppSelector((state) => state.drawer.data);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [DesignationDetail]);

  const formloading = useAppSelector((state) => state.designation.formloading);

  useEffect(() => {
    return () => {
      dispatch(clearDesignationDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (DesignationID) {
      dispatch(getDesignationByID(DesignationID));
    }
  }, [DesignationID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!DesignationID) {
        const insertPayload = {
          Title: values?.Title ? values?.Title : "",
          Description: values?.Description ? values?.Description : "",
          Position: values.Position ? values.Position : "",
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createDesignation(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearDesignationDetails());
          dispatch(getAllDesignation());
        }
      } else {
        const editPayload = {
          ID: DesignationID,
          Title: values?.Title ? values?.Title : "",
          Description: values?.Description ? values?.Description : "",
          Position: values.Position ? values.Position : "",
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateDesignation(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearDesignationDetails());
          dispatch(getAllDesignation());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
    dispatch(clearDesignationDetails());
  };

  return (
    <>
      {formloading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        initialValues={DesignationDetail}
        key={formKey}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
              <GridLayoutItem
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                <Typography.h4 className="m-0">
                  {DesignationID ? "Update Designation" : "Add Designation"}
                </Typography.h4>

                <IconButton
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                  icon={RxCross1}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="Title"
                  label="Title"
                  placeholder="Title"
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="Description"
                  label="Description"
                  placeholder="Description"
                  component={FormRichTextField}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="Position"
                  label="Department"
                  placeholder="Department"
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>

              <GridLayoutItem>
                <Field
                  id={"IsActive"}
                  name={"IsActive"}
                  label={"Status"}
                  placeholder="i.e. Active"
                  component={FormSelectionField}
                  validator={requiredValidator}
                  astrike={true}
                  options={STATUSARRAY?.map((status: any) => {
                    return {
                      value: status.value,
                      label: status.label,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  textAlign: "end",
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={DesignationID ? "Update" : "Save"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || formloading}
                  loading={formloading}
                />

                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 10 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateDesignation;
